export default __webpack_public_path__ + "static/oneblock-background-111f8291e7b684644644b3ed2a0e18e1.png";